import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useTranslation } from "react-i18next"
import { getUpdatedCart } from "../../../../v1/helpers/orderHelpers"
import { NoServiceFound } from "../../Services/NoServiceFound"
import { Button, Card, Divider, Header } from "semantic-ui-react"
import { ShimmerServiceCard } from "../../Services/ShimmerServiceCard"
import ServiceCard from "./ServiceCard"
import { updateCart } from "../../../../v1/actions/user"

const CategoryServices = (props) => {
  const [services, setServices] = useState([])
  const [popularServices, setPopularServices] = useState([])
  const [commonServices, setCommonServices] = useState([])
  const [selectedPositions, setSelectedPositions] = useState({})
  const [serviceErrors, setServiceErrors] = useState({})
  const [servicesUpdating, setServicesUpdating] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [selectedServices, setSelectedServices] = useState([])

  const { handleCancel, cart, defaultServices, relatedServices } = props
  const { t } = useTranslation("addService")

  useEffect(() => {
    const allServiceIds = cart.order_services.map((service) => service.id)
    setSelectedServices(allServiceIds)
    fetchCategoriesServices()
  }, [])

  const fetchCategoriesServices = async () => {
    setIsLoading(true)

    const categoryServices = defaultServices.concat(relatedServices)

    if (categoryServices !== null) {
      setServices(categoryServices)
      setPopularServices(defaultServices)
      setCommonServices(relatedServices)

      const selectedPositionsMap = cart.order_services.reduce((acc, service) => {
        if (service.position && service.position != "") {
          acc[service.id] = service.position
        }
        return acc
      }, {})
      categoryServices.forEach((service) => {
        if (service?.positions?.length > 0 && !selectedPositionsMap[service.id]) {
          selectedPositionsMap[service.id] = service.positions[0]
        }
      })
      setSelectedPositions(selectedPositionsMap)
    }
    setIsLoading(false)
  }

  const updateService = async (service, position = null) => {
    props.toggleService({
      service,
      positionOverride: position,
      cart: props.cart,
      order: props.order,
      vehicle: props.vehicle,
      selectedPositions,
      setSelectedPositions,
      setServiceErrors,
      setServicesUpdating,
      setSelectedServices,
      t,
      updateCart: props.updateCart
    })
  }

  const getPositions = (positions) => {
    return positions.map((position, index) => ({
      key: index,
      text: position,
      value: position
    }))
  }

  return (
    <Card className="service-card category-page" raised={true}>
      <Header as="h4">{props.firstLevelCategory}</Header>
      {isLoading && <ShimmerServiceCard count={5} />}
      <div className="category-services-list">
        {!isLoading &&
          popularServices &&
          popularServices.map((service, index) => (
            <React.Fragment key={service.id}>
              <ServiceCard
                service={service}
                selectedServices={selectedServices}
                isUpdating={servicesUpdating.includes(service.id)}
                selectedPositions={selectedPositions}
                serviceErrors={serviceErrors}
                handleService={updateService}
                updateServiceWithPosition={updateService}
                getPositions={getPositions}
              />
              {index != popularServices.length - 1 && <Divider fitted />}
            </React.Fragment>
          ))}
      </div>
      {commonServices.length > 0 && <Divider fitted />}
      {!isLoading && commonServices.length > 0 && (
        <div className="common-services">
          <Header as="h5" style={{ margin: 0 }}>
            Often Done Together
          </Header>
          <p style={{ margin: 0 }}>
            Mechanics often recommend checking these items during an oil change to ensure complete
            vehicle health.
          </p>
          {commonServices.map((service, index) => (
            <React.Fragment key={service.id}>
              <ServiceCard
                service={service}
                selectedServices={selectedServices}
                isUpdating={servicesUpdating.includes(service.id)}
                selectedPositions={selectedPositions}
                serviceErrors={serviceErrors}
                handleService={updateService}
                updateServiceWithPosition={updateService}
                getPositions={getPositions}
              />
              {index !== commonServices.length - 1 && <Divider fitted />}
            </React.Fragment>
          ))}
        </div>
      )}
      {!isLoading && services.length == 0 && (
        <NoServiceFound serviceName={`${props.firstLevelCategory}`} />
      )}
      <div className="action_button">
        <Button
          onClick={props.handleShowReviewServices}
          disabled={isLoading || servicesUpdating.length || selectedServices.length === 0}
          className="primary-button"
        >
          {t("continue")}
        </Button>
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  }

  return {
    cart: cart,
    user: user,
    activeVehicle,
    order
  }
}

export default connect(mapStateToProps, { updateCart })(CategoryServices)
